import * as React from 'react'

export default (props) =>
  <svg id="Icon_Plus" data-name="Icon / Plus" xmlns="http://www.w3.org/2000/svg" width="10.604" height="10.604" viewBox="0 0 10.604 10.604"  {...props}>
    <path id="Path_5574" data-name="Path 5574" d="M269,225.908v10.6" transform="translate(-263.7 -225.908)" fill="none" strokeWidth="1.5" />
    <path id="Path_5575" data-name="Path 5575" d="M0,0V10.6" transform="translate(10.604 5.302) rotate(90)" fill="none" strokeWidth="1.5" />
  </svg>

